export const trustItems = [
  { icon: "ri-time-line", label: "+19 anos de experiência" },
  { icon: "ri-map-pin-2-line", label: "Servidores no Brasil" },
  { icon: "ri-stack-line", label: "Infraestrutura profissional" },
  { icon: "ri-customer-service-2-line", label: "Suporte especializado" },
];

export const services = [
  {
    icon: "ri-server-line",
    title: "Hospedagem de Sites",
    description:
      "Hospedagem profissional para sites corporativos, projetos e negócios que precisam de estabilidade e desempenho.",
    cta: "Ver hospedagem",
    href: "/hospedagem",
  },
  {
    icon: "ri-hard-drive-3-line",
    title: "VPS & Servidores",
    description:
      "Mais recursos, controle e flexibilidade para projetos que precisam de uma infraestrutura mais robusta.",
    cta: "Conhecer servidores",
    href: "/servidores",
  },
  {
    icon: "ri-global-line",
    title: "Domínios",
    description:
      "Registre o endereço profissional da sua empresa e fortaleça sua presença digital.",
    cta: "Registrar domínio",
    href: "/dominios",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "Criação de Sites",
    description:
      "Sites modernos, responsivos e preparados para apresentar sua empresa de forma profissional.",
    cta: "Criar meu site",
    href: "/sites",
  },
  {
    icon: "ri-shopping-bag-3-line",
    title: "Lojas Virtuais",
    description:
      "Estruturas para empresas que desejam apresentar e vender seus produtos pela internet.",
    cta: "Conhecer",
    href: "/lojas-virtuais",
  },
  {
    icon: "ri-code-s-slash-line",
    title: "Sistemas Web",
    description:
      "Soluções digitais personalizadas para necessidades específicas da empresa.",
    cta: "Saiba mais",
    href: "/sistemas",
  },
];

export const hostingPlans = [
  {
    name: "Profissional",
    audience: "Para sites institucionais e pequenos negócios.",
    price: "50",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/profissional",
    badge: "",
    highlighted: false,
    features: [
      "Recursos configuráveis",
      "E-mail profissional",
      "Backups",
      "Suporte especializado",
    ],
  },
  {
    name: "Empresarial",
    audience: "Para empresas em crescimento.",
    price: "80",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagens-empresarial",
    badge: "Mais escolhido",
    highlighted: true,
    features: [
      "Recursos configuráveis",
      "E-mail profissional",
      "Backups",
      "Suporte prioritário",
    ],
  },
  {
    name: "Premium",
    audience: "Para projetos que precisam de mais recursos.",
    price: "120",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagem-premium",
    badge: "",
    highlighted: false,
    features: [
      "Recursos configuráveis",
      "E-mail profissional",
      "Backups",
      "Suporte prioritário",
    ],
  },
  {
    name: "Semi Dedicada",
    audience: "Para projetos com maior demanda.",
    price: "180",
    url: "https://nxhost.com.br/cliente/store/hospedagem-de-sites/hospedagem-dedicada",
    badge: "",
    highlighted: false,
    features: [
      "Recursos configuráveis",
      "E-mail profissional",
      "Backups",
      "Suporte dedicado",
    ],
  },
];

export const benefits = [
  {
    icon: "ri-map-pin-2-line",
    title: "Servidores no Brasil",
    description: "Infraestrutura localizada no Brasil, próxima do seu público.",
  },
  {
    icon: "ri-speed-up-line",
    title: "Performance",
    description: "Estrutura pensada para oferecer uma experiência rápida e estável.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Segurança",
    description: "Recursos de proteção para os seus projetos digitais.",
  },
  {
    icon: "ri-database-2-line",
    title: "Backups",
    description: "Estrutura preparada para proteção adicional dos seus dados.",
  },
  {
    icon: "ri-mail-send-line",
    title: "E-mail profissional",
    description: "Comunicação empresarial utilizando o domínio da sua empresa.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte",
    description: "Atendimento próximo para ajudar você quando precisar.",
  },
];

export const performanceMetrics = [
  { label: "Performance", value: "99%", icon: "ri-speed-up-line", tone: "primary" },
  { label: "Disponibilidade", value: "Alta", icon: "ri-signal-tower-line", tone: "secondary" },
  { label: "Velocidade", value: "Otimizada", icon: "ri-flashlight-line", tone: "accent" },
  { label: "Segurança", value: "Protegida", icon: "ri-lock-2-line", tone: "primary" },
];

export const growthBars = [34, 42, 38, 55, 49, 64, 72, 68, 84, 92];

export const businessSolutions = [
  {
    title: "Empresas corporativas",
    image:
      "https://readdy.ai/api/search-image?query=modern%20corporate%20office%20meeting%20room%20with%20glass%20walls%20and%20business%20team%20collaborating%2C%20premium%20technology%20company%20atmosphere%2C%20clean%20professional%20interior%2C%20soft%20blue%20lighting&width=800&height=600&seq=nh-sol-corp&orientation=landscape",
  },
  {
    title: "Indústrias",
    image:
      "https://readdy.ai/api/search-image?query=modern%20industrial%20manufacturing%20facility%20with%20automated%20machinery%20and%20engineer%20holding%20tablet%2C%20clean%20high%20tech%20environment%2C%20blue%20toned%20professional%20photography&width=800&height=600&seq=nh-sol-industria&orientation=landscape",
  },
  {
    title: "Distribuidores",
    image:
      "https://readdy.ai/api/search-image?query=modern%20logistics%20warehouse%20with%20organized%20shelves%20and%20delivery%20fleet%2C%20bright%20clean%20distribution%20center%2C%20professional%20corporate%20photography&width=800&height=600&seq=nh-sol-distribuidor&orientation=landscape",
  },
  {
    title: "Prestadores de serviços",
    image:
      "https://readdy.ai/api/search-image?query=professional%20service%20provider%20team%20working%20in%20modern%20bright%20office%2C%20consultant%20with%20laptop%20in%20clean%20corporate%20environment%2C%20natural%20light&width=800&height=600&seq=nh-sol-servicos&orientation=landscape",
  },
  {
    title: "Empresas B2B",
    image:
      "https://readdy.ai/api/search-image?query=business%20to%20business%20technology%20handshake%20in%20modern%20glass%20office%20lobby%2C%20corporate%20partnership%2C%20clean%20professional%20atmosphere&width=800&height=600&seq=nh-sol-b2b&orientation=landscape",
  },
  {
    title: "Lojas virtuais",
    image:
      "https://readdy.ai/api/search-image?query=modern%20ecommerce%20online%20store%20displayed%20on%20screen%20in%20clean%20studio%2C%20shopping%20concept%20with%20minimal%20product%20boxes%2C%20bright%20professional%20setup&width=800&height=600&seq=nh-sol-loja&orientation=landscape",
  },
  {
    title: "Revendas",
    image:
      "https://readdy.ai/api/search-image?query=network%20of%20servers%20and%20cloud%20infrastructure%20racks%20in%20modern%20data%20center%20with%20blue%20lighting%2C%20professional%20technology%20photography&width=800&height=600&seq=nh-sol-revenda&orientation=landscape",
  },
  {
    title: "Projetos personalizados",
    image:
      "https://readdy.ai/api/search-image?query=software%20developers%20working%20on%20custom%20digital%20dashboard%20on%20large%20screens%20in%20modern%20tech%20office%2C%20blue%20ambient%20lighting%2C%20professional&width=800&height=600&seq=nh-sol-custom&orientation=landscape",
  },
];

export const siteBenefits = [
  "Design moderno",
  "Sites multi-idiomas (Português, Inglês e Espanhol)",
  "Responsividade",
  "Experiência do usuário",
  "SEO",
  "Integração com WhatsApp",
  "Formulários",
  "Apresentação comercial",
  "Estrutura preparada para evolução",
];

export const vpsCards = [
  {
    icon: "ri-cloud-line",
    title: "VPS",
    description:
      "Recursos dedicados e liberdade para configurar o ambiente do seu projeto conforme a necessidade.",
  },
  {
    icon: "ri-server-line",
    title: "Servidores",
    description:
      "Estrutura robusta para aplicações que exigem mais desempenho e estabilidade.",
  },
  {
    icon: "ri-settings-5-line",
    title: "Infraestrutura personalizada",
    description:
      "Soluções montadas sob medida para demandas específicas da sua empresa.",
  },
];

export const resellerProgram = {
  priceFrom: "55,90",
  benefits: [
    {
      icon: "ri-price-tag-3-line",
      title: "Preços e margens de revenda",
      description: "Condições especiais para você revender com a sua margem de lucro.",
    },
    {
      icon: "ri-team-line",
      title: "Painel para gerenciar clientes",
      description: "Controle as contas dos seus clientes em um só lugar.",
    },
    {
      icon: "ri-award-line",
      title: "Sua marca no atendimento",
      description: "Atenda os seus clientes com a sua identidade e o seu jeito.",
    },
    {
      icon: "ri-headphone-line",
      title: "Suporte ao parceiro",
      description: "Você conta com a estrutura da NXHOST para crescer junto.",
    },
  ],
};

export const timeline = [
  { year: "2007", title: "Início da NXHOST", description: "Primeiros passos no segmento de tecnologia." },
  { year: "Evolução", title: "Hospedagem e infraestrutura", description: "Ampliação da estrutura de hospedagem." },
  { year: "Expansão", title: "Sites, lojas e soluções web", description: "Novos serviços digitais para empresas." },
  { year: "Hoje", title: "Hospedagem + servidores + soluções digitais", description: "Uma estrutura completa para o seu negócio." },
];

export const testimonials = [
  { quote: "Depoimento do cliente", company: "Nome da empresa", segment: "Segmento" },
  { quote: "Depoimento do cliente", company: "Nome da empresa", segment: "Segmento" },
  { quote: "Depoimento do cliente", company: "Nome da empresa", segment: "Segmento" },
];

export const faqs = [
  {
    question: "Qual plano de hospedagem devo escolher?",
    answer:
      "A escolha ideal depende do momento e da necessidade do seu projeto. Fale com um especialista para avaliarmos juntos a estrutura mais adequada para você.",
  },
  {
    question: "Posso migrar meu site para a NXHOST?",
    answer:
      "Fale com a nossa equipe para entender as opções de migração disponíveis e o que é necessário para levar o seu site para a NXHOST.",
  },
  {
    question: "Vocês trabalham com VPS?",
    answer:
      "Sim. Oferecemos soluções de VPS e servidores para projetos que precisam de mais recursos, controle e flexibilidade. Veja a seção de VPS e servidores.",
  },
  {
    question: "Vocês criam sites?",
    answer:
      "Sim. Desenvolvemos sites modernos, responsivos e preparados para apresentar a sua empresa de forma profissional.",
  },
  {
    question: "Vocês trabalham com lojas virtuais?",
    answer:
      "Sim. Criamos estruturas para empresas que desejam apresentar e vender seus produtos pela internet.",
  },
  {
    question: "Posso registrar meu domínio?",
    answer:
      "Sim. Registre o endereço profissional da sua empresa e fortaleça a sua presença digital com a NXHOST.",
  },
  {
    question: "Como funciona o suporte?",
    answer:
      "Nossa equipe oferece atendimento próximo para ajudar quando você precisar. Fale com um especialista para conhecer as condições atuais de atendimento.",
  },
  {
    question: "Preciso de ajuda para escolher um plano?",
    answer:
      "Claro. Conte o que você precisa e a nossa equipe ajuda você a encontrar a solução mais adequada para o seu projeto.",
  },
];